import React,{useEffect, useState, useMemo} from 'react';
import { CacheProvider } from '@emotion/react';
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import { useParams } from 'react-router-dom';
import getReq from '../interface/getRequestinterface';
import { getRequest, postRequest } from '../request';
import { Box, Divider, Fab, IconButton, TextField, Tooltip, Typography, Button } from '@mui/material';
import { useMediaQuery } from 'react-responsive';
import { Add, Check, CheckCircle, Close, Delete, Edit, Title } from '@mui/icons-material';
import DeleteModal from '../components/deleteModal.tsx';
import axios from 'axios';
import { toast } from 'react-toastify';
import postReq from '../interface/postRequestinterface';

const style={
    formTitle:{
      fontWeight:'bold !important'
    },
    formDescription:{
      color:'#9b9b9b'
    },
    formContainer:{
      padding: '1rem !important',
      border: '3px solid #748DA6',
      backgroundColor: '#f1f7ff59',
      height:'fit-content',
      borderRadius:'0.5rem',
      width:'80%',
      marginBottom:'1rem',
      display:'flex',
      marginTop:'1rem',
      flexDirection:'column'
    },
    titleContainer:{
      padding: '1rem !important',
      border: '3px solid #f37e7b',
      backgroundColor: '#ef9a9a33',
      height:'fit-content',
      borderRadius:'0.5rem',
      width:'80%',
      marginBottom:'1rem'
    },
    container:{
      display:'flex',
      alignItems:'center',
      flexDirection:'column',
      
    },
    gridBox:{
      display:'grid',
      gridTemplateColumns:'40% 40%',
      columnGap:'5%',
      rowGap:'3%',
      justifyContent:'space-around',
      marginTop:'2rem'
    },
    mobileGridBox:{
      display:'grid',
      gridTemplateColumns:'90%',
      // columnGap:'5%',
      rowGap:'3%',
      justifyContent:'center',
      marginTop:'2rem'
    },
    modalStyle :{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      p: 4,
      backgroundColor:'#fff',
      display:'flex',
      flexDirection:'column',
      borderRadius:'3px',
      width:'30rem'
    },
    modalMobileStyle:{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      p: 4,
      backgroundColor:'#fff',
      display:'flex',
      flexDirection:'column',
      borderRadius:'3px',
      width:'15rem'
    },
    txtField:{
      width:'100%', 
    },
    headerContainer:{
      display:'flex',
      width:'100%',
      justifyContent:'space-between'
    },
    stateType:{
      fontWeight:'bold'
    },
    title:{
      display:'flex',
      justifyContent:'space-between',
      width:'65rem',
    },
    unShown:{
      visibility:'none'
    },
    editFab:{
      backgroundColor:'#4caf50',
      color:'#efefef',
      marginLeft:'1rem',
      '&:hover':{
        backgroundColor:'#24a329',
      }
    }
  }
  
  interface QuestionString{
    question:string;
    questionId:number;
  }
  interface QuestionList{
    pollformName:string;
    pollformId:number;
    filled:boolean;
    description:string;
    questions:QuestionString[];
  }

function ExpertCheckPoll() {
    const params = useParams();
    const [deletedQuestion, setDeletedQuestion] = useState<number>(-1);
    const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
    const [deletedSuccessful, setDeletedSuccessful] = useState<boolean>(false);
    const [questionList, setQuestionList] = useState<Array<QuestionList>>([]);
    const [isEditTitle, setIsEditTitle] = useState<boolean>(false);
    const [pollTitle, setPollTitle] = useState<string>('');
    const [isAddQuestion, setIsAddQuestion] = useState<boolean>(false);
    const [questionText, setQuestionText] = useState<string>('');
    const cacheRtl = useMemo(() => {
      return createCache({
        key: "muirtl",
        stylisPlugins: [prefixer, rtlPlugin]
      });
    }, []);
    const isDesktop = useMediaQuery({
        query: "(min-width: 1224px)"
      });
      
      const isTablet = useMediaQuery({
        query: "(max-width: 768px)"
      });
      
      const isMobile = useMediaQuery({
        query: "(max-width: 400px)"
      });

    const fetchPollForm=async()=>{
        const {data,error}:getReq = await getRequest(`${process.env.REACT_APP_BASE_URL}/Poll/GetAllForms`) as getReq;
        if(!error){
            setQuestionList(data.filter(form=>form.pollformId == params.pollformId).map(x=>({
                pollformName:x.pollformName,
                pollformId:x.pollformId,
                filled:x.filled,
                description:x.description,
                questions:x.questions.map(q=>({question:q.questionString,questionId:q.questionId}))
            })));
            setPollTitle(data.filter(form=>form.pollformId == params.pollformId)[0].pollformName);
        }
    }
    useEffect(() => {
      fetchPollForm()
    }, []);
    const token = localStorage.getItem('token');
    const handleDeleteQuestion=(pollformId)=>{
        setDeletedQuestion(pollformId);
        setOpenDeleteModal(true);
    }
    const handleEditPollTitle=async()=>{
      const tempData ={
        pollformId:questionList[0].pollformId,
        pollformName:pollTitle
      }
      const response :any = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/Poll/EditPollFormName`,
        tempData,
       {headers: { Authorization: `Bearer ${token}`}}
      );
      if(response.status === 200){
        toast.success('عملیات با موفقیت انجام شد!')
        window.location.reload();
      }else{
        toast.error('عملیات با مشکل مواجه شد. لطفا دوباره تلاش کنید!')
      }
    }
    const handleAddNewQuestion=async()=>{
      const tempData = {
        pollformId:questionList[0].pollformId,
        questionString:questionText
      }
      const {message,error}: postReq = await postRequest(`${process.env.REACT_APP_BASE_URL}/Poll/SetQuestion`,tempData) as postReq;
      if(message === 'ok'){
        toast.success('سوال با موفقیت ثبت شد');
        window.location.reload();
      }else{
        toast.error(error);
      }
    }
  return (
    <CacheProvider value={cacheRtl}>
        <div className='background'>
            <Box sx={style.container}>
                <Box sx={isDesktop?
                        {height:'4rem',display:'flex',alignItems:'center',width:'80%'}:
                        isMobile?
                        {height:'4rem',display:'flex',alignItems:'center',width:'80%',marginBottom:'3rem',marginTop:'2.5rem'}:
                        {height:'4rem',display:'flex',alignItems:'center',width:'80%'}
                    }
                >
                  {isEditTitle?
                    <TextField
                      label="عنوان"
                      size='small'
                      value={pollTitle}
                      onChange={(e)=>setPollTitle(e.target.value)}
                      sx={{marginTop:'1rem'}}
                    />:
                    <Typography variant="h5" sx={{fontWeight:'bold'}}>
                        {questionList[0]?.pollformName}
                    </Typography>
                  }
                  {isEditTitle?
                  <Box>
                    <Tooltip title='اعمال تغییر'>
                      <Fab onClick={handleEditPollTitle} color='primary' sx={{marginLeft:'1rem',marginTop:'1rem'}} size='small'>
                        <Check/>
                      </Fab>
                    </Tooltip>
                    <Tooltip title='انصراف'>
                      <Fab onClick={()=>setIsEditTitle(false)} color='secondary' sx={{marginLeft:'1rem',marginTop:'1rem'}} size='small'>
                        <Close/>
                      </Fab>
                    </Tooltip>
                  </Box>:
                  <Tooltip title='ویرایش عنوان'>
                    <Fab onClick={()=>setIsEditTitle(true)} sx={style.editFab} size='small'>
                      <Edit/>
                    </Fab>
                  </Tooltip>
                  }
                </Box>
                <Box sx={style.formContainer} >
                {
                  questionList[0]?.questions?.map((q,index)=>
                  <Box key={index} >
                    <Box sx={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                      <Typography variant="body1" color="initial" sx={{padding:'1rem 0rem', textAlign:'justify'}}>
                      {index+1}:
                      {
                        q.question
                      }                             
                      </Typography>
                      <Tooltip title='حذف سوال'>
                      <IconButton aria-label="" onClick={()=>handleDeleteQuestion(q.questionId)}>
                          <Delete color='secondary'/>
                      </IconButton>
                      </Tooltip>
                    </Box>
                      <Divider orientation='horizontal'/>
                  </Box>
                  )
                }
                {
                  isAddQuestion?
                  <Box sx={{marginTop:'1rem'}}>
                    <TextField
                      multiline
                      rows='3'
                      label="متن سوال"
                      value={questionText}
                      onChange={(e)=>setQuestionText(e.target.value)}
                      sx={{width:'100%'}}
                    />
                    <Button variant="contained" color="primary" sx={{marginTop:'1rem'}} onClick={handleAddNewQuestion}>
                      ثبت سوال<Check/>
                    </Button>
                  </Box>
                  :<Button variant="contained" color="primary" sx={{width:'fit-content',marginTop:'1rem'}} onClick={()=>setIsAddQuestion(true)}>
                  سوال جدید<Add/>
                </Button>
                }
                
                </Box>
            </Box>
        </div>
        <DeleteModal 
            deleteURL={`${process.env.REACT_APP_BASE_URL}/Poll/RemoveQuestion/${deletedQuestion}`}
            setOpenDeleteModal={setOpenDeleteModal}
            openDeleteModal={openDeleteModal}
            destination=''
            parameterName='سوال'
            setIsSuccessful={setDeletedSuccessful}
        />
    </CacheProvider>
  )
}

export default ExpertCheckPoll